import { render } from "./ContratoUsuarioDialog.vue?vue&type=template&id=2d9e8ed6"
import script from "./ContratoUsuarioDialog.vue?vue&type=script&lang=js"
export * from "./ContratoUsuarioDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__